<template>
	<div class="component-index mt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<v-row no-gutters class="mb-2 ml-2 flex-row-reverse">
				<v-btn color="primary" @click="openSearchDialog">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					検索
				</v-btn>
			</v-row>
			<div>
				<div class="table-container px-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="requirements"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item, index }">
							<LogisticsRecord
								:recordIndex="index"
								:requirement="item"
								:answer="item.answer"
								:matter="item.matter"
								:orderedProduct="item.ordered_product"
								:orderIndividualInfo="item.order_individual_info"
								:deliveryInfo="item.order_individual_info.delivery_info"
								@reloadIndex="fetchRequirements(pagination.current)"
							/>
						</template>
					</v-data-table>

					<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
				</div>
			</div>
		</CommonFlame>
		<LogisticsSearchDialog ref="search" @searchReq="searchReq" />
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import LogisticsRecord from "./components/LogisticsRecord.vue"
import LogisticsSearchDialog from "./components/LogisticsSearchDialog.vue"
export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		LogisticsRecord,
		LogisticsSearchDialog,
	},
	data() {
		return {
			mainTitle: "",
			title: "物流台帳",
			headers: [],
			requirements: [],
			searched: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			searchWord: null,
			selected: null,
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		this.fetchRequirements(1)
		this.setTableHeaders()
	},
	methods: {
		searchReq(searchWord = "", selected = "") {
			this.searchWord = searchWord
			this.selected = selected
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/logistics/requirements_search.json", {
					headers,
					params: { word: searchWord, type: selected, page: this.pagination.current },
				})
				.then((res) => {
					this.requirements = res.data.requirements
					console.log(this.requirements)
					this.pagination = res.data.pagination
					this.searched = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			if (this.searched) {
				this.searchReq(this.searchWord, this.selected)
			} else {
				this.fetchRequirements(i)
			}
		},
		openSearchDialog() {
			this.$refs.search.openDialog()
		},
		fetchRequirements(page) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/logistics`, { params: { page: page }, headers })
				.then((res) => {
					this.requirements = res.data.requirements
					this.pagination = res.data.pagination
					this.searched = true
					console.log(res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setTableHeaders() {
			this.headers = [
				{
					text: "出荷日",
					value: "shipping_date",
					width: "135px",
					filter: null,
					class: "px-1 font-size-075rem sticky-01",
				},
				{
					text: "品種",
					value: "product_type",
					width: "40px",
					filter: null,
					class: "px-1 font-size-075rem sticky-02",
				},
				{
					text: "製番",
					value: "product_number",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem sticky-03",
				},
				{
					text: "枝番",
					value: "product_sub_number",
					width: "40px",
					filter: null,
					class: "px-1 font-size-075rem sticky-04",
				},
				{
					text: "営業担当者",
					value: "user_name",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem sticky-05",
				},
				{
					text: "受注No.",
					value: "order_number",
					width: "55px",
					filter: null,
					class: "px-1 font-size-075rem sticky-06",
				},
				{
					text: "出荷許可日",
					value: "shipping_permit_date",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "出荷許可者",
					value: "permit_user",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "品名",
					value: "product_name",
					width: "285px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "寸法等",
					value: "product_sub_name",
					width: "285px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "数量",
					value: "quantity",
					width: "55px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "受注先",
					value: "regular_customer",
					width: "185px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "出荷先",
					value: "customer_company",
					width: "185px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "都道府県",
					value: "prefecture",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "市郡町村",
					value: "city",
					width: "120px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "納期",
					value: "deadline",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "特記事項",
					value: "remarks",
					width: "80px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "運送方法",
					value: "transportation_method",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "車種",
					value: "car_model",
					width: "95px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "台数",
					value: "number_of_cars",
					width: "40px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "荷姿",
					value: "packing",
					width: "95px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "個数",
					value: "number_of_packing",
					width: "40px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "重量(kg)",
					value: "number_of_packing",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "備考",
					value: "note",
					width: "300px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "梱包指定",
					value: "packing_specification",
					width: "120px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "送品案内",
					value: "shipping_information",
					width: "60px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "指定伝票",
					value: "designated_voucher",
					width: "60px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "成績書",
					value: "transcripts",
					width: "50px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "現品表",
					value: "specimen_list",
					width: "45px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "返信封筒",
					value: "return_envelope",
					width: "60px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "図面",
					value: "drawing",
					width: "45px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "地図",
					value: "drawing",
					width: "45px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "出荷許可",
					value: "permission",
					width: "60px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "運送費",
					value: "shipping_charges",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "運賃",
					value: "fare",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "中継料",
					value: "relay_fee",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "冬季割増料",
					value: "winter_surcharge",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "保険料",
					value: "insurance_premium",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "チャーター料",
					value: "charter_fee",
					width: "85px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "受領書",
					value: "receipt",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "発注＆受入したか",
					value: "ordered_accepted",
					width: "160px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "見積番号",
					value: "quote_number",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "見積日",
					value: "quote_date",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "オーナミ",
					value: "onami_price",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "日本ロジコム",
					value: "japan_logicom_price",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "城南運輸",
					value: "onami_price",
					width: "115px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
			]
		},
	},
	computed: {},
}
</script>
